import { useRequest } from 'ahooks';
import { loadTextMarkResource } from '@meitu/saas-editor-core/es/layers/text-layer';
import { editor } from '@/instance';
import { fetchArtTextMaterials, fetchFontCategoryList, fetchListStyleMaterials } from '@/services/font';
import { toEditorFormat, transformArtTextMaterialRaw, transformListStyleMaterialRaw } from '@/services/font/transform';
import { fetchTextMark } from '@/services/material';
import { useStoreActions } from '@/store';
import { getQuery } from '@/utils/query';
import { getCommonParams } from '@/utils/request';

export const useFontMaterials = () => {
    const setFonts = useStoreActions((state) => state.fontMaterialModel.setFonts);
    const setListStyles = useStoreActions((state) => state.fontMaterialModel.setListStyles);
    const setArtTexts = useStoreActions((state) => state.fontMaterialModel.setArtTexts);
    const query = getQuery();
    const { loading, runAsync } = useRequest(fetchFontCategoryList, {
        manual: true,
    });

    const { loading: isLoadingListStyles, runAsync: fetchListStyles } = useRequest(fetchListStyleMaterials, {
        manual: true,
    });

    const { loading: isLoadingArtTexts, runAsync: fetchArtTexts } = useRequest(fetchArtTextMaterials, {
        manual: true,
    });

    const loadFontMaterials = async () => {
        try {
            const params = getCommonParams();
            const [data, listStyleList, artTextList] = await Promise.all([
                runAsync({ ...params, app_src: query.app_src || '' }),
                fetchListStyles(),
                fetchArtTexts(),
                loadTextMarkResource(fetchTextMark),
            ]);
            const fonts = (data as any).reduce((acc: any, cur: any) => {
                return acc.concat(
                    cur.materials.map((el: any) => {
                        el.category_id = cur.category_id;
                        return el;
                    }),
                );
            }, []);
            setFonts(fonts);
            setListStyles(listStyleList.map(transformListStyleMaterialRaw));
            setArtTexts(artTextList.map(transformArtTextMaterialRaw));

            editor.font.setList(toEditorFormat(fonts));
        } catch (error) {
            // TODO: 处理错误
            console.log('初始化字体素材失败', error);
        }
    };

    return {
        loading,
        loadFontMaterials,
        isLoadingListStyles,
        isLoadingArtTexts,
    };
};
